module.exports = __webpack_public_path__ + "img/background-remover-product-before.ffc51ab6.jpg";